import { useEffect } from "react";

function Analytics() {
  const isProduction = process.env.REACT_APP_ENV === "production";

  useEffect(() => {
    if (isProduction) {
      // Google Tag Manager
      const gtmScript = document.createElement("script");
      gtmScript.async = true;
      gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=GTM-564WGJ2P";
      document.head.appendChild(gtmScript);

      // Microsoft Clarity
      const clarityScript = document.createElement("script");
      clarityScript.type = "text/javascript";
      clarityScript.innerHTML = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/omgefh27wf";
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "omgefh27wf");
      `;
      document.head.appendChild(clarityScript);
    }
  }, [isProduction]);

  // Add noscript only in production
  return isProduction ? (
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-564WGJ2P"
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
        title="Google Tag Manager"
      ></iframe>
    </noscript>
  ) : null;
}

export default Analytics;
